/**
 * SB5-B.1 — TanStack Query keys for the contracts feature.
 */
import type { ListContractsParams } from "./types.js";

export const contractsKeys = {
  all: ["contracts"] as const,
  lists: () => [...contractsKeys.all, "list"] as const,
  list: (params: ListContractsParams) =>
    [...contractsKeys.lists(), params] as const,
  facets: () => [...contractsKeys.all, "facets"] as const,
  projectsFacet: () => [...contractsKeys.facets(), "projects"] as const,
  sitesFacet: () => [...contractsKeys.facets(), "sites"] as const,
  customersFacet: () => [...contractsKeys.facets(), "customers"] as const,
  contractorsFacet: () => [...contractsKeys.facets(), "contractors"] as const,
  statesFacet: () => [...contractsKeys.facets(), "states"] as const,
};
